import { numberWithSpaces } from "../../utils/numberWithSpaces";
import classNames from "classnames";

import { Text } from "../text/text";

import styles from "./incomeFormulaItem.module.css"

export const IncomeFormulaItem = ({ title, value, type = null, big = false }) => {
    return (
        <div className={classNames(styles.income_formula_item, styles[type], { [styles.big]: big })}>
            <Text as="div" size={14} className={styles.income_formula_item_title} >
                {title}
            </Text>
            <Text as="div" size={16} weight={700} className={styles.income_formula_item_value} >
                {numberWithSpaces(value)} ₽
            </Text>
        </div>
    );
}
